const style = {
    chatButton: {
        backgroundColor: '#3a5a40',
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        fontSize: '50px',
        cursor: 'pointer',
        borderRadius: '100px',
        border: 'none',
        boxShadow: '0 5px 10px #ccc',
        height: '55px',
        minWidth: '40px',
    },

    faqModal: {
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        // width: {
        //     xs: '90%',
        //     md: '45%',
        // },
        // p: 2,
        // background: '#fff',
        // borderRadius: '5px',
        height: '100%',
        overflow: 'scroll',
    },

    mainAccordion: {
        backgroundColor: '#ebebeb',
    },

    titleAccordion: {
        fontFamily: 'poppins',
        fontSize: '14px',
        color: '#000',
    },

    expandIconMore: {
        color: '#000',
    },

    childAccordion: {
        backgroundColor: '#d6d6d6',
    },

    questionAccordion: {
        fontFamily: 'poppins',
        fontSize: '14px',
        color: '#000',
    },

    answerText: {
        fontFamily: 'poppins',
        fontSize: '14px',
        color: '#000',
    },

    faqBox: {
        height: '5vh',
        backgroundColor: '#2e8359',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        margin: '0px 0px 10px 0px',
    },

    faqText: {
        fontFamily: 'semibold',
        color: '#fff',
    },
}
export default style;